<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="title-block">
<h1>Contents</h1>
</div>
<p class="toc1"><br/>
<span href="#/9781847675651_booktitlepage" title="Link target outside of Sample">Title Page</span><br/>
<a href="#/9781847675651_introduction">Introduction</a><br/><br/>
<a href="#/9781847675651_part_01">Book One: Wahn, Wahn, überall Wahn …</a><br/>
<a href="#/9781847675651_chapter_01">Chapter One</a><br/>
<a href="#/9781847675651_chapter_02">Chapter Two</a><br/>
<span href="#/9781847675651_chapter_03" title="Link target outside of Sample">Chapter Three</span><br/>
<span href="#/9781847675651_chapter_04" title="Link target outside of Sample">Chapter Four</span><br/>
<span href="#/9781847675651_chapter_05" title="Link target outside of Sample">Chapter Five</span><br/>
<span href="#/9781847675651_chapter_06" title="Link target outside of Sample">Chapter Six</span><br/><br/>
<span href="#/9781847675651_part_02" title="Link target outside of Sample">Book Two: Was gilt’s, Was Ich Dir Sagen Kann? …</span><br/>
<span href="#/9781847675651_chapter_07" title="Link target outside of Sample">Chapter One</span><br/>
<span href="#/9781847675651_chapter_08" title="Link target outside of Sample">Chapter Two</span><br/>
<span href="#/9781847675651_chapter_09" title="Link target outside of Sample">Chapter Three</span><br/>
<span href="#/9781847675651_chapter_10" title="Link target outside of Sample">Chapter Four</span><br/>
<span href="#/9781847675651_chapter_11" title="Link target outside of Sample">Chapter Five</span><br/>
<span href="#/9781847675651_chapter_12" title="Link target outside of Sample">Chapter Six</span><br/><br/>
<span href="#/9781847675651_abouttheauthor" title="Link target outside of Sample">About the Author</span><br/>
<span href="#/9781847675651_insertedcopyright" title="Link target outside of Sample">Copyright</span><br/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847675651_toc.vue?35891c39